import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './emailChipsInput.style';

const EmailChipsInput = ({
  onEmailsChange,
  initialValue = [],
  autoFocus = false,
  disabled = false,
}) => {
  const [emails, setEmails] = useState(initialValue);
  const [inputValue, setInputValue] = useState('');

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const handleAddEmail = (email) => {
    if (isValidEmail(email) && !emails.includes(email)) {
      const newEmails = [...emails, email];
      setEmails(newEmails);
      onEmailsChange(newEmails);
    }
    setInputValue('');
  };

  const handleInputChange = ({ target: { value } }) => {
    setInputValue(value);

    if (value.includes(',') || value.includes(' ')) {
      handleAddEmail(value.replace(/[, ]+/g, '').trim());
    }
  };

  const handleRemoveEmail = (email) => {
    const updatedEmails = emails.filter((e) => e !== email);
    setEmails(updatedEmails);
    onEmailsChange(updatedEmails);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      e.preventDefault();
      handleAddEmail(inputValue.trim());
    }
  };

  const handleBlur = () => handleAddEmail(inputValue.trim());

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.chips}>
        {emails.map((email) => (
          <Box key={email} sx={styles.chip}>
            {email}
            <CloseIcon
              data-testid="CloseIcon"
              sx={styles.icon}
              onClick={() => handleRemoveEmail(email)}
            />
          </Box>
        ))}
      </Box>
      <TextField
        autoFocus={autoFocus}
        sx={styles.input}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        disabled={disabled}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder="Type emails..."
      />
    </Box>
  );
};

export default EmailChipsInput;
